<template>
  <div>
    <el-dialog
      title="账号设置"
      center
      :visible="true"
      @before-close="onClose"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="
        form.isMustSetAddress == null ? true : !form.isMustSetAddress
      "
      width="700px"
    >
      <el-form ref="form" :model="form" label-width="220px" size="mini">
        <el-form-item label="通知地址类型：" prop="addressType">
          <el-select
            @change="addressTypeChange"
            style="width: 150px"
            v-model="form.addressType"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in availableAddressTypes"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-tooltip effect="dark" placement="top" style="margin-left: 10px">
            <div slot="content">
              通知地址用于后台给账号推送重要通知，请务必准确填写
            </div>
            <span
              ><i class="el-icon-question" style="font-size: 1.5em"></i
            ></span>
          </el-tooltip>
          <span v-if="form.addressType == '企业微信'">
            <span class="link-button" @click="openGetUserIdDialog()"
              >点击获取通知地址</span
            >
          </span>
        </el-form-item>
        <el-form-item label="通知地址：" prop="">
          <el-input
            :disabled="form.addressType == '企业微信'"
            v-model="form.address"
            clearable
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="this.$bizutil.getLoginUserRole() == '管理员'"
          label="参与敏感业务操作的投票"
          prop="isReceiveCorpNotifications"
        >
          <el-switch
            v-model="form.isReceiveCorpNotifications"
            active-color="#13ce66"
          >
          </el-switch>
        </el-form-item>

        <el-form-item
          v-if="this.$bizutil.getLoginUserRole() == '管理员'"
          label="敏感业务操作需要经过投票："
          prop="isAuditedWithOperation"
        >
          <el-switch
            v-model="form.isAuditedWithOperation"
            active-color="#13ce66"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="onClose"
          :disabled="
            form.isMustSetAddress == null ? false : form.isMustSetAddress
          "
          >取消</el-button
        >
        <el-button type="primary" @click="submit()" style="margin-left: 30px"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "SettingDialog";

export default {
  data() {
    return {
      form: {
        username: "",
        role: "",
        address: "",
        addressType: "",
        isReceiveCorpNotifications: true,
        isMustSetAddress: false,
        isAuditedWithOperation: true,
      },
      availableAddressTypes: [],
    };
  },
  components: {},

  async created() {
    await this.loadAvailableAddressTypes();
    this.form = bizutil.getLoginUser();
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      this.update();
    },

    /**
     * 修改密码
     */
    async update() {
      if (this.form.addressType.trim().length == 0) {
        this.$message({
          message: "请选择通知地址类型",
          type: "fail",
        });
        return;
      }
      if (this.form.address.trim().length == 0) {
        this.$message({
          message: "通知地址不能为空",
          type: "fail",
        });
        return;
      }

      try {
        // 弹确认框
        await this.$confirm(`确认更新设置？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updateMyProfile`,
            this.form,
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        await bizutil.queryMyProfile();

        this.$message({
          message: "更新成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose(null);
      } catch (e) {}
    },
    async loadAvailableAddressTypes() {
      this.availableAddressTypes = [];
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/corpflow/queryCorpMemberAddressTypes`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.types || [];
      for (let item of listInResponse) {
        this.availableAddressTypes.push(item);
      }
    },
    addressTypeChange() {
      this.form.address = "";
    },
    async openGetUserIdDialog() {
      this.$dialogutil.open("GetUserIdDialog", {
        closedCallback: (param) => {
          if (param != null) {
            this.form.address = param;
          }
        },
        data: { addressType: this.form.addressType, app: "notify" },
      });
    },
    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>

<style scoped>
.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}
</style>